module.exports = __webpack_public_path__ + "img/Frame_26.ac74882d.png";